import { useTranslation } from "react-i18next";
import { InstallationSchema } from "types/installation";
import { formattedDateTime, validateDateTime } from "utils/global";
import TogglingInput from "./orderModal/TogglingInput";

export default function Done({
  installation,
}: {
  installation: InstallationSchema;
}) {
  const { t } = useTranslation();
  return (
    <div>
      <h5 className="underline">{t("general:done")}:</h5>
      <div className="flex gap-4">
        <div className="flex-1">
          <TogglingInput
            name="additionalSetupDoneDateTime"
            label={`${t("orders:barrierDetails.setupDate")} / ${t(
              "orders:time"
            )}`}
            originalValue={formattedDateTime(installation.setupDoneDateTime)}
            updatedValue={
              installation.additionalInformation?.additionalSetupDoneDateTime ??
              ""
            }
            placeholder="YYYY-MM-DD HH:mm"
            rules={[
              {
                validator: validateDateTime,
              },
            ]}
          />
        </div>
        <div className="flex-1">
          <b>
            {t("orders:barrierDetails.pickupDate")} / {t("orders:time")}:
          </b>
          <p className="m-0">
            {formattedDateTime(installation.pickupDoneDateTime) || "-"}
          </p>
        </div>
      </div>
    </div>
  );
}
